module.exports = __webpack_public_path__ + "static/media/soon.ab8378ba.png";